angular.module('impactx.catalog').controller('CatalogBackToProfessionalCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    CatalogBackToProfessionalCtrl]);

function CatalogBackToProfessionalCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService) {
    var self = this;

    dataGen.getData($scope, {catId: self.catId}, "/catalog/backtopurchaser/data").then(function () {
        if ($scope.data.purchasers) {
            setDefaultImages($scope.data.purchasers);
        }
    });

    self.querySearch = function (criteria) {
        return $scope.data.purchasers.filter(createFilterFor(criteria, $scope.data.selectedPurchasers));
    };

    self.hide = function () {
        $mdDialog.hide();
    };

    self.close = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        var transferData = {
            catId: $scope.data.catId,
            approvalSettings: $scope.data.approvalSettings,
            comment: $scope.data.comment,
            purchasers: $scope.data.purchasers,
            selectedPurchasers: $scope.data.selectedPurchasers
        };
        dataGen.postAsForm($scope, {formData: transferData}, '/catalog/backtopurchaser/save').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            self.hide();
        })
    };

    function createFilterFor(query, filterList) {
        var lowercaseQuery = query.toLowerCase();

        return function filterFn(contact) {
            return (contact.name.toLowerCase().indexOf(lowercaseQuery) !== -1) && filterList.indexOf(contact) < 0;
        };

    }

    function setDefaultImages(users) {
        angular.forEach(users, function (user) {
            if (!user.image) {
                user.image = "img/profile_image_default.png";
            }
        })
    }
}